// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subHeader_subHeader__hyuXZ {
  display: flex;
  align-items: center;
  gap: 0.2rem;
}
.subHeader_subHeader__img__9P84i {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: contain;
}
.subHeader_subHeader__text__a5Kl7 {
  margin: 0;
}

.subHeader_subHeaderBlock__4Q5Cw {
  align-items: center;
  gap: 0.2rem;
}
.subHeader_subHeaderBlock__img__TgvA0 {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: contain;
}
.subHeader_subHeaderBlock__text__H0g\\+F {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/subHeader.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;AACJ;AAAI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AAER;AACI;EACI,SAAA;AACR;;AAGA;EACI,mBAAA;EACA,WAAA;AAAJ;AACI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AACR;AAEI;EACI,SAAA;AAAR","sourcesContent":[".subHeader {\n    display: flex;\n    align-items: center;\n    gap: 0.2rem;\n    &__img {\n        width: 30px;\n        height: 30px;\n        border-radius: 50%;\n        object-fit: contain;\n    }\n\n    &__text {\n        margin: 0;\n    }\n}\n\n.subHeaderBlock {\n    align-items: center;\n    gap: 0.2rem;\n    &__img {\n        width: 30px;\n        height: 30px;\n        border-radius: 50%;\n        object-fit: contain;\n    }\n\n    &__text {\n        margin: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subHeader": `subHeader_subHeader__hyuXZ`,
	"subHeader__img": `subHeader_subHeader__img__9P84i`,
	"subHeader__text": `subHeader_subHeader__text__a5Kl7`,
	"subHeaderBlock": `subHeader_subHeaderBlock__4Q5Cw`,
	"subHeaderBlock__img": `subHeader_subHeaderBlock__img__TgvA0`,
	"subHeaderBlock__text": `subHeader_subHeaderBlock__text__H0g+F`
};
export default ___CSS_LOADER_EXPORT___;
